import { render, staticRenderFns } from "./EditDepositDialog.vue?vue&type=template&id=33eb5347"
import script from "./EditDepositDialog.vue?vue&type=script&lang=js"
export * from "./EditDepositDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports